module.exports = __webpack_public_path__ + "img/logo-herbario-tefh-rodape.dc0a1a5c.png";